import { createSelector } from 'reselect';
import { RootState } from '../../store';

const stateSelector = (state: RootState) => state.graphHMIVisibility;

export const selectHmiPlayerVisibility = createSelector(
    stateSelector,
    visibility => visibility.visible,
);
